import { render, staticRenderFns } from "./TrueidFrame.vue?vue&type=template&id=4ed34290&scoped=true&"
import script from "./TrueidFrame.vue?vue&type=script&lang=js&"
export * from "./TrueidFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed34290",
  null
  
)

export default component.exports